// @flow

import React from 'react'
import styled from 'styled-components'
import Colors from 'components/styles/colors'
import { mediaMin } from 'frontend_core/dist/styles/media'

const Link = styled.a`
  display: ${props => (props.inline ? 'inline' : 'inline-block')};
  color: ${props => Colors.primaryColors[props.service]};
  font-size: ${props =>
    props.fontSizeSp ? `${props.fontSizeSp}px` : 'inherit'};
  border-bottom: 1px solid rgba(0, 0, 0, 0);
  cursor: pointer;

  &:hover {
    border-bottom: 1px solid ${props => Colors.primaryColors[props.service]};
  }
  ${mediaMin.phone`
    font-size: ${props =>
      props.fontSizePc ? `${props.fontSizePc}px` : 'inherit'};
  `};
`

type PropTypes = {
  id?: string,
  href?: string,
  onClick?: (e: Event) => void,
  fontSizePc?: string | number,
  fontSizeSp?: string | number,
  target?: string,
  children: any,
  inline?: ?boolean,
}

export default (props: PropTypes) => (
  <Link
    id={props.id}
    href={props.href}
    onClick={props.onClick}
    fontSizePc={props.fontSizePc}
    fontSizeSp={props.fontSizeSp}
    target={props.target || '_self'}
    inline={props.inline}
  >
    {props.children}
  </Link>
)



// WEBPACK FOOTER //
// ./src/components/atoms/LinkText/index.jsx